import { PUBLIC_SITE_ORIGIN } from '../constants/ApplicationConstants';

const LOVIBOOK_ROOT_DOMAIN = 'lovibook.com';
const RESERVED_SUBDOMAINS = new Set([
  'admin',
  'api',
  'app',
  'account',
  'accept-terms',
  'assets',
  'auth',
  'billing',
  'book',
  'booking',
  'cdn',
  'contact',
  'dashboard',
  'dev',
  'developer',
  'docs',
  'email',
  'ftp',
  'help',
  'imap',
  'login',
  'mail',
  'ns1',
  'ns2',
  'pop',
  'preview',
  'privacy',
  'privacy-policy',
  'provider-dashboard',
  'signup',
  'smtp',
  'staging',
  'static',
  'status',
  'support',
  'test',
  'terms',
  'terms-of-service',
  'www',
]);
const VALID_SUBDOMAIN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export function getBookingSubdomainSlug(hostname?: string): string | null {
  const normalizedHostname = hostname?.trim().toLowerCase().replace(/\.$/, '') ?? '';
  const suffix = `.${LOVIBOOK_ROOT_DOMAIN}`;
  if (!normalizedHostname.endsWith(suffix)) {
    return null;
  }

  const subdomain = normalizedHostname.slice(0, -suffix.length);
  if (!VALID_SUBDOMAIN.test(subdomain) || RESERVED_SUBDOMAINS.has(subdomain)) {
    return null;
  }
  return subdomain;
}

export function buildBookingPageUrl(
  bookingSlug: string,
  customSubdomainActive: boolean,
  pathOrigin = PUBLIC_SITE_ORIGIN,
): string {
  if (customSubdomainActive) {
    return `https://${bookingSlug}.${LOVIBOOK_ROOT_DOMAIN}`;
  }
  return `${pathOrigin.replace(/\/+$/, '')}/${bookingSlug}/booking`;
}
